import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import ErrorFallback from './components/ErrorFallback.tsx';
import { initBugsnag, getErrorBoundary } from './services/bugsnag.service';
import { initDatadog } from './services/datadog.service';

import './index.css';

initBugsnag();
initDatadog();

const ErrorBoundary = getErrorBoundary();
const root = createRoot(document.getElementById('root')!);
root.render(
  ErrorBoundary ? (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <App />
    </ErrorBoundary>
  ) : (
    <App />
  )
);
